import { Button } from '../../../core';

export interface ActionButtonProps {
  readonly label: string;
  readonly variant?: 'primary' | 'subtle';
  readonly onClick: () => void;
}

export function ActionButton({ label, variant = 'primary', onClick }: ActionButtonProps) {
  return (
    <Button onClick={onClick} variant={variant === 'primary' ? 'filled' : 'subtle'}>
      {label}
    </Button>
  );
}
